export default __webpack_public_path__ + "static/techguru-example2-f7b10c4b1ca149d1a83ab7dda7466bde.png";